//#region src/logger/helpers/generateMetadata.ts
var e = (e) => {
	let t = {};
	return e.requestId && (Object.assign(t, { req: { requestId: e.requestId } }), delete e.requestId), e.statusCode && (Object.assign(t, { res: { statusCode: e.statusCode } }), delete e.statusCode), e.startAt && (Object.assign(t, { responseTime: (/* @__PURE__ */ new Date()).getTime() - e.startAt }), delete e.startAt), { meta: Object.assign(t, e) };
};
//#endregion
export { e as generateMetadata };

//# sourceMappingURL=generateMetadata.js.map